import React from 'react';
// import { Link } from 'react-router-dom'
import { Row, Col, Layout } from 'antd'
import get from 'lodash/get'

import ResetSendForm from '../../components/ResetSendForm/ResetSendForm';
import Footer from '../../components/Footer/Footer';
import classes from './ResetPasswordSend.css';

import isNotAuthenticated from '../../utils/isNotAuthenticated';

const { Content } = Layout;

class ResetPasswordSend extends React.Component {
  render() {
      const token = get(this.props, 'match.params.token');

      return (
          <div style={{ backgroundColor: '#FAFAFA' }}>
              <Layout className={classes.parentContainer}>
                  <Content className={classes.content}>
                      <Row>
                          <Col xs={{ span: 24 }} sm={{ span: 20, offset: 2 }} md={{ span: 16, offset: 4 }} style={{ paddingTop: '4rem' }}>
                              <Row type='flex' justify='center'>
                                  <Col xs={24} sm={18} md={18} lg={20} xl={12} className={classes.loginForm}>
                                    <ResetSendForm token={token} history={this.props.history} />
                                  </Col>
                              </Row>
                          </Col>
                      </Row>
                  </Content>
                  <Footer noAdminLink />
              </Layout>
          </div>
      );
    }
}

export default isNotAuthenticated(ResetPasswordSend);



// WEBPACK FOOTER //
// ./src/containers/ResetPasswordSend/ResetPasswordSend.js